import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserService } from 'src/app/core/services/user-service.service';
import { SnackbarService } from 'src/app/core/services/snackbar.service';

export interface ApiConfig {
  mca?: boolean;
  legalCheck?: boolean;
  socialMediaAnalysis?: boolean;
}

export interface ApiConfigModalData {
  userId: string;
  userName: string;
  apiConfig: ApiConfig;
}

@Component({
  selector: 'app-api-config-modal',
  templateUrl: './api-config-modal.component.html',
  styleUrls: ['./api-config-modal.component.scss']
})
export class ApiConfigModalComponent {
  apiConfigForm: FormGroup;
  isLoading: boolean = false;

  configOptions = [
    { key: 'mca', label: 'MCA', icon: 'business', description: 'Ministry of Corporate Affairs data access' },
    { key: 'legalCheck', label: 'Legal Check', icon: 'gavel', description: 'Legal verification and compliance' },
    { key: 'socialMediaAnalysis', label: 'Social Media Analysis', icon: 'share', description: 'Social media insights and analytics' }
  ];

  constructor(
    public dialogRef: MatDialogRef<ApiConfigModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ApiConfigModalData,
    private fb: FormBuilder,
    private userService: UserService,
    private snackbarService: SnackbarService
  ) {
    this.apiConfigForm = this.fb.group({
      mca: [data.apiConfig?.mca ?? false],
      legalCheck: [data.apiConfig?.legalCheck ?? false],
      socialMediaAnalysis: [data.apiConfig?.socialMediaAnalysis ?? false]
    });
  }

  onSubmit(): void {
    this.isLoading = true;
    
    const apiConfig: ApiConfig = {
      mca: this.apiConfigForm.value.mca,
      legalCheck: this.apiConfigForm.value.legalCheck,
      socialMediaAnalysis: this.apiConfigForm.value.socialMediaAnalysis
    };

    this.userService.updateApiConfig(this.data.userId, apiConfig).subscribe({
      next: () => {
        this.snackbarService.showSuccess('API Config updated successfully!');
        this.dialogRef.close(true);
      },
      error: (error: any) => {
        this.snackbarService.showError(error.error?.message || 'Failed to update API Config!');
        this.isLoading = false;
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}

